import React, { Component, createRef, Fragment } from "react";
import { connect } from "react-redux";
import * as queryString from "query-string";
import { bindActionCreators } from "redux";
import { fromJS } from "immutable";
import { ActionCreator } from "actions";
import "containers/ShowMore/Jackpots/styles.scss";
import { ReactComponent as PreviousIcon } from "assets/icons/previous.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { CommonHeader } from "component/common";
import { TournamentTypeListItem } from "component/listItem";

const SEE_ALL_MODAL = "SEE_ALL_MODAL";
class ShowMoreJackpots extends Component {
  constructor(props) {
    super(props);
    this.seeMoreRef = createRef();
    this.onGameItemClickHandler = this._onGameItemClickHandler.bind(this);
    this.onSeeAllScrollHandler = this._onSeeAllScrollHandler.bind(this);
    this.getTournamentPreview = this._getTournamentPreview.bind(this);
    this.onClickPrevious = this._onClickPrevious.bind(this);
    this.onShowMoreHandler = this._onShowMoreHandler.bind(this);
    this.onShowTournamentDetailsHandler = this._onShowTournamentDetailsHandler.bind(
      this
    );
    this.onShowTournamentResultHandler = this._onShowTournamentResultHandler.bind(
      this
    );
    this.state = {
      skeleton: [1, 2, 3, 4, 5, 6],
      showCategoryLabel: false,
    };
  }

  _onShowTournamentDetailsHandler(rel, links, images, providers, tab) {
    let params = {
      showTournamentDetails: rel,
      routes: btoa(encodeURIComponent(JSON.stringify(links.toJSON()))),
      tab: tab,
    };

    if (images) {
      params.images = btoa(encodeURIComponent(JSON.stringify(images.toJSON())));
    }

    if (providers) {
      params.providers = btoa(
        encodeURIComponent(JSON.stringify(providers.toJSON()))
      );
    }

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;
    this.props.navigateTo(newLoc);
  }

  _onShowTournamentResultHandler(rel, route, images, providers) {
    let params = {
      showTournamentResults: rel,
      route: btoa(encodeURIComponent(JSON.stringify(route.toJSON()))),
    };

    if (images) {
      params.images = btoa(encodeURIComponent(JSON.stringify(images.toJSON())));
    }

    if (providers) {
      params.providers = btoa(
        encodeURIComponent(JSON.stringify(providers.toJSON()))
      );
    }

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;
    this.props.navigateTo(newLoc);
  }

  _onShowMoreHandler(rel, route, images, providers) {
    let params = {
      showMore: rel,
      route: btoa(encodeURIComponent(JSON.stringify(route.toJSON()))),
    };

    if (images) {
      params.images = btoa(encodeURIComponent(JSON.stringify(images.toJSON())));
    }

    if (providers) {
      params.providers = btoa(
        encodeURIComponent(JSON.stringify(providers.toJSON()))
      );
    }

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;
    this.props.navigateTo(newLoc);
  }

  _onClickPrevious() {
    this.props.goBack(
      `${this.props.location.pathname}${this.props.location.search}`
    );
    this.props.history.goBack();
  }

  _getTournamentPreview(links) {
    if (!links) return;

    let link = links.find((link) => {
      return link.get("rel").indexOf("tournament.preview") > -1;
    });
    if (link)
      this.props.fetchTournamentPreview(link, {
        parentRel: this.props.link.get("rel"),
      });
  }

  _onGameItemClickHandler(game, rel) {
    let gameId = game.get("gameId");
    let nav = this.props.link ? this.props.link.get("rel") : null;
    this.props.gameClick(gameId, rel, nav).then((response) => {
      if (response.location) {
        this.props.navigateTo(response.location);
      } else if (response.params) {
        this.props.setGameAction(response.params);
      }
    });
  }

  _onSeeAllScrollHandler(event) {
    const scrollDemo = document.querySelector(".show-more-tournaments-modal");
    if (scrollDemo.scrollTop !== 0) {
      this.setState({ showCategoryLabel: true });
    } else {
      this.setState({ showCategoryLabel: false });
    }

    if (!this.props.games) return;
    let { page } = this.props.games.toJSON();

    if (
      this.props.games &&
      this.props.games.get("totalPages") === this.props.games.get("page")
    ) {
      return;
    }

    let positionToload =
      event.target.scrollHeight - event.target.offsetHeight * 2;
    let scrollTop = event.target.scrollTop;

    if (
      scrollTop > positionToload &&
      !this.props.isLoading &&
      !this.state.isLoadingNext
    ) {
      let nextPage = page + 1;
      let params = {
        size: 25,
        page: nextPage,
      };
      this.setState({
        isLoadingNext: true,
      });
      this.props.fetchGames(this.props.link, params).then(() => {
        this.setState({
          isLoadingNext: false,
        });
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showMoreRel !== this.props.showMoreRel) {
      if (!nextProps.showMoreRel) {
        this.props.hideModal(SEE_ALL_MODAL);
      } else {
        this.props.showModal(SEE_ALL_MODAL);
      }
    }
  }

  renderSeeAllListItem(item, key) {
    let ListItem = TournamentTypeListItem;
    let detailsLink = item.get("links").find((link) => {
      return link.get("rel").indexOf("tournament-promotions") > -1;
    });
    let resultsLink = item.get("links").find((link) => {
      return link.get("rel").indexOf("tournament-leaderboard") > -1;
    });
    let images = item.get("images");
    let providers = item.get("providers");
    let templateSize = this.props.template ? this.props.template.get("size") : "l";

    return (
      <ListItem
        className={`col template-${templateSize}`}
        key={key}
        game={item}
        isMobile={this.props.isMobile}
        fetchGameTypes={this.props.fetchGameTypes}
        onClick={(rel) => {
          let links = item.get("links");
          let tab;
          links.forEach((link, key) => {
            links = links.setIn([key, "name"], item.get("title"));
          });
          resultsLink ? (tab = "results") : (tab = "games");
          this.onShowTournamentDetailsHandler(
            detailsLink.get("rel"),
            links,
            images,
            providers,
            tab
          );
        }}
        onShowActionClick={() => {}}
        onViewGamesClick={(rel) => {
          let links = item.get("links");
          links.forEach((link, key) => {
            links = links.setIn([key, "name"], item.get("title"));
          });
          this.onShowTournamentDetailsHandler(
            detailsLink.get("rel"),
            links,
            images,
            providers,
            "games"
          );
        }}
        onViewResultsClick={(rel) => {
          let links = item.get("links");
          links.forEach((link, key) => {
            links = links.setIn([key, "name"], item.get("title"));
          });
          this.onShowTournamentDetailsHandler(
            detailsLink.get("rel"),
            links,
            images,
            providers,
            "results"
          );
        }}
        currency={this.props.currency}
        symbol={this.props.symbol}
        imageFormat={this.props.imageFormat}
      />
    );
  }

  render() {
    if (!this.props.showMoreRel) return null;

    return (
      <Fragment>
        <div
          ref={this.seeMoreRef}
          className="show-more-tournaments-modal"
          onScroll={this.onSeeAllScrollHandler}
        >
          <div className="header">
            {this.props.link && (
              <CommonHeader
                link={this.props.link}
                tournamentComponent={true}
                showCategoryLabel={this.state.showCategoryLabel}
                tournamentPreview={this.props.tournamentPreview}
                detailsAvailable={this.props.detailsAvailable}
                onInfoClick={() => {
                  let params = this.props.qs;
                  params.tournamentDetails = this.props.link.get("rel");

                  let newLoc = `${
                    this.props.location.pathname
                  }?${queryString.stringify(params)}`;
                  this.props.navigateTo(newLoc);
                }}
                leftPanel={() => {
                  return (
                    <span
                      className="float-left prev-btn"
                      onClick={this.onClickPrevious}
                    >
                      <PreviousIcon width="34" />
                    </span>
                  );
                }}
                rightPanel={() => {
                  return (
                    <CloseIcon
                      width="34"
                      onClick={() => {
                        this.props.navigateTo(this.props.location.pathname);
                      }}
                    />
                  );
                }}
              />
            )}
          </div>

          <div className="content">
            {!this.props.tournamentPreview && (
              <span className={`label`}>            
                {this.props.route && this.props.route.get("name")}
                {!this.props.route && <span className="dummy">XXXXXXXX</span>}
              </span>
            )}

            <div
              className="row"
              style={{
                maxHeight: `${this.props.height}px`,
              }}
            >
              {this.props.games &&
                this.props.games.getIn(["items"]).map((game, key) => {
                  return this.renderSeeAllListItem(game, key);
                })}
              {(!this.props.games ||
                this.props.isLoading ||
                this.state.isLoadingNext) && (
                <Fragment>
                  {this.state.skeleton.map((key2) => {
                    return (
                      <TournamentTypeListItem
                        key={key2}
                        className={
                          this.props.template
                            ? `template-${this.props.template.get("size")}`
                            : ""
                        }
                      />
                    );
                  })}
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let qs = queryString.parse(window.location.search);
  let { showMore, route } = qs;
  let links;
  let link;
  let games;
  let template;
  let tournamentPreview;
  let isLoading = true;
  let detailsAvailable = false;
  let qsroute;

  try {
    qsroute = fromJS(JSON.parse(decodeURIComponent(atob(route))));
  } catch (err) {}

  try {
    link = state.games.getIn([showMore, "route"]);
    games = state.games.getIn([showMore, "data"]);
    isLoading = state.games.getIn([showMore, "isLoading"]);
    tournamentPreview = state.tournaments.getIn([showMore]);
    detailsAvailable = state.games.getIn([link.get("rel"), "route", "links"])
      ? true
      : false;
  } catch (err) {}
  try {
    let qsroute = fromJS(JSON.parse(decodeURIComponent(atob(route))));
    template = qsroute.getIn(["templates"]).find((template) => {
      return template.get("id") === "myQT";
    });
  } catch (err) {}
  try {
    links = state.pages
      .getIn(["wl-pages", 0, "content"])
      .find((contentItem) => {
        return contentItem.get("rel") === "tournament.games";
      })
      .get("links")
      .find((link) => {
        return link.get("rel") === showMore;
      })
      .get("links");
  } catch (err) {}

  return {
    isMobile: state.window.get("isMobile"),
    qs,
    detailsAvailable,
    showMoreRel: showMore,
    links,
    link,
    template,
    games,
    tournamentPreview,
    isLoading,
    route: qsroute,
    isMultiGame: state.links.get("isMultiGame"),
    imageFormat: state.window.get("imageFormat"),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    fetchGames: (route, params) => dispatchProps.fetchGames(route, params),
    navigateTo: (path) => ownProps.history.push(path),
    showModal: (modal) => dispatchProps.showModal(modal),
    hideModal: (modal) => dispatchProps.hideModal(modal),
    fetchTournamentPreview: (link, params) =>
      dispatchProps.fetchTournamentPreview(link, params),
    fetchGameTypes: (route) => dispatchProps.fetchGameTypes(route),
    gameClick: (gameId, playType, nav) =>
      dispatchProps.gameClick(gameId, playType, nav),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ShowMoreJackpots);
